import React from 'react';

const MasterCard = ({ ...r }) => {
	return (
		<svg
			width="50"
			height="32"
			viewBox="0 0 50 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...r}
		>
			<rect
				x="0.367188"
				width="48.8421"
				height="32"
				rx="4"
				fill="url(#paint0_linear_716_36748)"
			/>
			<path d="M20.7891 8.80859H29.387V22.8549H20.7891V8.80859Z" fill="#F26122" />
			<path
				d="M21.7144 15.8314C21.7002 13.0975 22.942 10.5085 25.0829 8.8082C21.4199 5.92761 16.1582 6.3459 12.9964 9.76905C9.83455 13.1922 9.83455 18.4705 12.9964 21.8937C16.1582 25.3168 21.4199 25.7351 25.0829 22.8545C22.942 21.1543 21.7002 18.5652 21.7144 15.8314Z"
				fill="#EA1D25"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M38.6743 21.0775V21.3638H38.6238V21.0775H38.5059V21.0186H38.8006V21.0775H38.6743ZM39.2469 21.0186V21.3638H39.188V21.1028L39.0953 21.3301H39.028L38.9269 21.1028V21.3638H38.868V21.0186H38.9522L39.0616 21.2628L39.1627 21.0186H39.2469Z"
				fill="#F69E1E"
			/>
			<path
				d="M39.5326 15.8314C39.5304 19.2498 37.5779 22.3673 34.5034 23.8616C31.4289 25.3558 27.7713 24.9649 25.082 22.8546C28.9558 19.8044 29.6266 14.1929 26.581 10.3156C26.1444 9.75416 25.641 9.24797 25.082 8.80824C27.7713 6.69792 31.4289 6.30698 34.5034 7.80123C37.5779 9.29549 39.5304 12.413 39.5326 15.8314Z"
				fill="#F69E1E"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_716_36748"
					x1="0.367188"
					y1="32"
					x2="49.2093"
					y2="-2.45428e-06"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#1C1C1F" />
					<stop offset="1" stop-color="#4C4C55" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default MasterCard;
